import { ref } from '@vue/runtime-core';
import { defineStore } from 'pinia';

export const useRateLimitStore = defineStore('rateLimit', () => {
  const isModalOpen = ref(false);
  const message = ref('');
  const duration = ref(60);

  const showRateLimitModal = (errorMessage?: string, durationSeconds = 60) => {
    console.log('[STORE] showRateLimitModal called with:', errorMessage, durationSeconds);
    message.value = errorMessage || "Vous avez effectué trop de requêtes. Veuillez patienter quelques instants avant de réessayer.";
    duration.value = durationSeconds;
    isModalOpen.value = true;
    console.log('[STORE] Modal state updated:', { isModalOpen: isModalOpen.value, message: message.value, duration: duration.value });
  };

  const closeRateLimitModal = () => {
    console.log('[STORE] closeRateLimitModal called');
    isModalOpen.value = false;
  };

  const handleTimeout = () => {
    console.log('[STORE] handleTimeout called - reloading page');
    isModalOpen.value = false;
    // Optionnel : recharger la page
    window.location.reload();
  };

  return {
    isModalOpen,
    message,
    duration,
    showRateLimitModal,
    closeRateLimitModal,
    handleTimeout
  };
});
